import { useSession, SessionContextValue } from 'next-auth/react';

type DisableableSessionContextValue<R extends boolean = false> = R extends true
  ? SessionContextValue<true> | { data: null; status: 'disabled' }
  : SessionContextValue<false> | { data: null; status: 'disabled' };

const defaultAnonymousSession = {
  status: 'disabled',
  data: null,
} as DisableableSessionContextValue<boolean>;

const useSafeSession = (): DisableableSessionContextValue => {
  // Early-exit with anonymous context if site does not support authentication
  if (process.env.SKIP_AUTHENTICATION === 'true') {
    return defaultAnonymousSession;
  }
  try {
    // While this absolutely does break rules of hooks by calling a hook conditionally,
    // in this case it's OK because authentication will always be enabled or disabled
    // for a given site
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useSession();
  } catch (e) {
    const nextAuthSessionError =
      '[next-auth]: `useSession` must be wrapped in a <SessionProvider />';
    if ((e as Error)?.message === nextAuthSessionError) {
      return defaultAnonymousSession;
    }
    throw e;
  }
};

export default useSafeSession;
